import styled from "styled-components";

import ErrorComponent from "components/app/Error/ErrorComponent";
import { API_STATUS_CODES } from "legacy/constants/ApiConstants";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - ${(props) => props.theme.legacy.headerHeight});
  background-color: #fafafa;
  text-align: center;
  padding-top: calc(${(props) => props.theme.legacy.headerHeight});
  .bold-text {
    font-weight: ${(props) => props.theme.legacy.fontWeights[3]};
    font-size: 24px;
  }
  .page-unavailable-img {
    width: 35%;
  }
  .button-position {
    margin: auto;
  }
`;

const ResourceForbidden = () => {
  const resourceTypeName = "resource";
  return (
    <Wrapper>
      <ErrorComponent
        errorCode={API_STATUS_CODES.RESOURCE_FORBIDDEN}
        title={"You do not have access"}
        errorMessage={`Sorry you don’t have access to this ${resourceTypeName}. Reach out to your team for access or contact support if you believe this is an error.`}
        buttonText="Find admins"
        handleButtonClick={() => {
          window.location.href = "/users";
        }}
        secondaryButtonText="Return home"
        secondaryButtonAction={() => {
          window.location.href = "/";
        }}
      />
    </Wrapper>
  );
};

export default ResourceForbidden;
